import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";

const FormatIIIAForm = forwardRef(({ formData, setFormData, vfcs }, ref) => {
  const [entries, setEntries] = useState(
    Array.isArray(formData.formatIIIA) ? formData.formatIIIA : []
  );

  useImperativeHandle(ref, () => ({
    validate: () => {
      return entries.every(
        (entry) =>
          entry.year &&
          entry.medicalCampCount >= 0 &&
          entry.vetCampsHeld >= 0 &&
          entry.beneficiariesMale >= 0 &&
          entry.beneficiariesFemale >= 0 &&
          entry.beneficiariesTotal >= 0 &&
          entry.departmentInvolved &&
          entry.lineDepartmentInvolved &&
          entry.nametapVillage
      );
    },
  }));

  const addEntry = () => {
    const updated = [
      ...entries,
      {
        year: "",
        medicalCampCount: 0,
        beneficiariesMale: 0,
        beneficiariesFemale: 0,
        beneficiariesTotal: 0,
        vetCampsHeld: 0,
        cattleBenefited: 0,
        departmentInvolved: "",
        lineDepartmentInvolved: "",
        nametapVillage: "",
      },
    ];
    setEntries(updated);
    setFormData({ ...formData, formatIIIA: updated });
  };

  const handleEntryChange = (index, field, value) => {
    const updated = entries.map((entry, i) =>
      i === index ? { ...entry, [field]: value } : entry
    );
    setEntries(updated);
    setFormData({ ...formData, formatIIIA: updated });
  };
  const generateYearRanges = (startYear, endYear) => {
    const ranges = [];
    for (let year = startYear; year < endYear; year++) {
      ranges.push(`${year}-${year + 1}`);
    }
    return ranges;
  };

  const yearRanges = generateYearRanges(1999, new Date().getFullYear());
  return (
    <div>
      {entries.map((entry, index) => (
        <Form key={index} className="border rounded p-3 mb-4 bg-light">
          <Row className="mb-3">
            <Col md={4}>
              <Form.Group controlId={`year-${index}`}>
                <Form.Label>Year</Form.Label>
                <Form.Control
                  as="select"
                  placeholder="Year"
                  value={entry.year}
                  onChange={(e) =>
                    handleEntryChange(index, "year", e.target.value)
                  }
                >
                  <option value="">Select Year</option>
                  {yearRanges.map((yr) => (
                    <option key={yr} value={yr}>
                      {yr}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group controlId={`medicalCampCount-${index}`}>
                <Form.Label>Medical Camps</Form.Label>
                <Form.Control
                  type="number"
                  min={0}
                  value={entry.medicalCampCount}
                  onChange={(e) =>
                    handleEntryChange(index, "medicalCampCount", e.target.value)
                  }
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group controlId={`vetCampsHeld-${index}`}>
                <Form.Label>Vet Camps Held</Form.Label>
                <Form.Control
                  type="number"
                  min={0}
                  value={entry.vetCampsHeld}
                  onChange={(e) =>
                    handleEntryChange(index, "vetCampsHeld", e.target.value)
                  }
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <Form.Group controlId={`beneficiariesMale-${index}`}>
                <Form.Label>Male Beneficiaries</Form.Label>
                <Form.Control
                  type="number"
                  min={0}
                  value={entry.beneficiariesMale}
                  onChange={(e) =>
                    handleEntryChange(
                      index,
                      "beneficiariesMale",
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group controlId={`beneficiariesFemale-${index}`}>
                <Form.Label>Female Beneficiaries</Form.Label>
                <Form.Control
                  type="number"
                  min={0}
                  value={entry.beneficiariesFemale}
                  onChange={(e) =>
                    handleEntryChange(
                      index,
                      "beneficiariesFemale",
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group controlId={`beneficiariesTotal-${index}`}>
                <Form.Label>Total Beneficiaries</Form.Label>
                <Form.Control
                  type="number"
                  min={0}
                  value={entry.beneficiariesTotal}
                  onChange={(e) =>
                    handleEntryChange(
                      index,
                      "beneficiariesTotal",
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId={`departmentInvolved-${index}`}>
                <Form.Label>Department Involved</Form.Label>
                <Form.Control
                  type="text"
                  value={entry.departmentInvolved}
                  onChange={(e) =>
                    handleEntryChange(
                      index,
                      "departmentInvolved",
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId={`lineDepartmentInvolved-${index}`}>
                <Form.Label>Line Department Involved</Form.Label>
                <Form.Control
                  type="text"
                  value={entry.lineDepartmentInvolved}
                  onChange={(e) =>
                    handleEntryChange(
                      index,
                      "lineDepartmentInvolved",
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId={`nametapVillage-${index}`}>
                <Form.Label>VFC (Nametap Village)</Form.Label>
                <Form.Select
                  value={entry.nametapVillage}
                  onChange={(e) =>
                    handleEntryChange(index, "nametapVillage", e.target.value)
                  }
                >
                  <option value="">Select VFC</option>
                  {vfcs.map((vfc) => (
                    <option key={vfc._id} value={vfc._id}>
                      {vfc.vfcName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      ))}
      <Button variant="primary" onClick={addEntry}>
        Add Entry
      </Button>
    </div>
  );
});

export default FormatIIIAForm;
